const SDKMsg = {
    install (Vue) {
        if (window.vuplex) {
            Vue.prototype.$PostMsg = window.vuplex.postMessage
        } else {
            window.addEventListener('vuplexready', function () {
                Vue.prototype.$PostMsg = window.vuplex.postMessage
            })
        }
    }
}
export default SDKMsg



// WEBPACK FOOTER //
// ./src/tool/postMsgSDK.js